// import React from 'react';
// import styles from './hero.module.scss';

// const Hero = () => {
//   return (
//     <div className={styles.container}>
//       <p>
//         {`We're a makers’ studio dreaming up wonderful experiences across the web and in real life, for brands who have something to say.`}
//       </p>
//     </div>
//   );
// };

// export default Hero;

import React, { useState, useEffect } from 'react';
import styles from './hero.module.scss';

const Hero = () => {
  const fullText =
    "We're a makers' studio dreaming up wonderful experiences across the web and in real life, for brands who have something to say.";
  const [text, setText] = useState('');
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (currentIndex < fullText.length) {
      const timeout = setTimeout(() => {
        setText((prevText) => prevText + fullText[currentIndex]);
        setCurrentIndex((prevIndex) => prevIndex + 1);
      }, 50); // Adjust typing speed (lower = faster)

      return () => clearTimeout(timeout);
    }
  }, [currentIndex, fullText]);

  return (
    <div className={styles.container}>
      <span>{text}</span>
      <span className={styles.cursor}>|</span>
    </div>
  );
};

export default Hero;
